import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import i18n from 'utils/i18n';

// loading the sass style fot the component
import css from './styles.module.scss';

/**
 * Molecule TagInput
 * 
 * An input that allows users to add tag like values.
 */
function TagInput (props) {
  const gt = i18n.useTranslations('global');

  const {
    className = "",
    children,
    label = '',
    value = [],
    name,
    type="text",
    inputProps,
    id,
    onChange,
    ...other
  } = props;

  function prepareValues (values) {
    return values.map(val => val.value || val);
  }

  function prepareOptions (value) {

    return (value || []).map(item => {
      if (typeof item !== 'object') {
        return { key: item, value: item, text: item };
      }

      return {
        // ...item,
        key: item.key || item.value,
        value: item.value,
        text: item.text
          || item.label
          || item.name
          || item.title
          || item.value
      };
    });
  }

  // const theValue = value || (multiple ? [] : '');
  const theValue = value || [];

  return <div
    className={`${css["molecule__tag-input-container"]} ${className}`}
    {...other}
  >
    <div className="field">
      {
        other.required
          && (
            <input
              type={type}
              value={value?.toString() || ""}
              className='hidden-input'
              required
            />
          )
      }
      {label && <label>{label}{other.required ? "*" : ""}</label>}
      <Dropdown
        fluid
        deburr
        id={id}
        name={name}
        multiple
        search
        additionLabel={gt('enter-key')}
        noResultsMessage={gt('enter-tags')}
        defaultOpen={false}
        selection
        clearable
        closeOnChange
        selectOnBlur={false}
        allowAdditions
        inputProps={inputProps}
        options={prepareOptions(value)}
        onAddItem={(event, target) => {
          const theValue = prepareValues(Array.from(new Set([
            ...(value || []),
            target.value
          ])));

          target = { name, value: theValue?.value || theValue };
          onChange && onChange({
            target
          }, target);
        }}
        onChange={onChange}
        value={theValue}
      />
    </div>
  </div>;
}

export default TagInput;
